import { userConstants } from 'store/constants/userConst';

export const setUserAccountDetails = userAccountDetails => ({
  type: userConstants.SET_USER_ACCOUNT_DETAILS,
  userAccountDetails,
});
